"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 24px !important;\n  width: 24px !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  > * {\n    font-size: 12px !important;\n    display: block !important;\n    height: 12px;\n    width: 12px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtraSmallButton = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

function ExtraSmallButton(props) {
  return react_1.default.createElement(StyledExtraSmallButton, Object.assign({
    shape: 'circle',
    size: 'small'
  }, props));
}

exports.ExtraSmallButton = ExtraSmallButton;
var StyledExtraSmallButton = (0, styledTypes_1.styled)(antd_1.Button)(_templateObject());